export * from '../_generated/content-type';
